import { parse_response_data } from "./esigning_setup_helpers";
import { esigning_setup_case_methods } from "./esigning_setup_case_methods";
import { esigning_setup_history_methods } from "./esigning_setup_history_methods";
import { esigning_setup_request_methods } from "./esigning_setup_request_methods";

export const esigning_setup_methods = {
    parse_response_data,
    ...esigning_setup_case_methods,
    ...esigning_setup_history_methods,
    ...esigning_setup_request_methods
};
